/*!
 *  1/9/2019, 5:27:28 PM
 *  Copyright 2019 FT, DK Techin Corp 
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var $coll = (0, _jquery2['default'])('#comColl');
	var $tabs = $coll.find('#stockTab li');
	var $img = $coll.find('#stockTabImg');
	var $move = $img.parent('a');
	var chartInfoList = C._1CI.chartInfoList;
	
	$tabs.on('click', function () {
	  var $this = (0, _jquery2['default'])(this);
	  $tabs.filter('.on').removeClass('on');
	  $this.addClass('on');
	  $img.attr('src', chartInfoList[$this.index()]["img"]);
	  $move.attr('href', C._1CI.chartInfoList[$this.index()]["landingUrl"]);
	  var r = $this.index() + 1;
	  $move.attr('onClick', 'smartLog(this, "dc=1CI&p=6&r=' + r + '&pg=1&d=KOSPI-035720", event);');
	});

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** 1CI/1CI.bundle.cb386f9.js
 **/